import React from 'react'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useSelector } from 'react-redux';

const AdBanners = ({}) => {

    const globalData = useSelector((state) => state.globalData);

    return (
        <div className="container">

            {
                !globalData || globalData?.homeBanners?.length === 0 ? (
                    <>
                        <Skeleton
                            className="md:h-[200px] h-[100px]"
                        />

                    </>
                ) : (
                    <div className="row">
                        <Carousel
                            showIndicators={false}
                            showThumbs={false}
                            interval={3000}
                            autoPlay={true}
                            infiniteLoop
                        >

                            {
                                globalData?.homeBanners?.filter((ad) => ad.imageUrl).map((item, index) => (
                                    <div className="md:h-[200px] h-[100px]" key={index}>
                                        <img src={item?.imageUrl} className="rounded-md h-full " alt="Egasi Ad" />

                                    </div>
                                ))
                            }
                        </Carousel>

                    </div>
                )
            }

        </div>
    )
}

export default AdBanners